import DataTableModule from '~/lib/vue/modules/datatable';
import rest from '~/lib/rest';
import lang from '~/lib/lang';
import date from '~/lib/date';
import constants from '~/lib/domain/constants';

/**
 * @param {~/lib.foundation.Container} services
 * @return {Object}
 */
export default (services, namespace='datatable') => {

  return DataTableModule.create({
    namespace,
    services,
    url: '/jobs',
    columns: [
      {
        label: 'ID',
        value: row => row.id,
      },
      {
        label: 'Customer',
        value: ({customer}) => customer.type === constants.CUSTOMER_TYPE_COMPANY ? customer.name : `${customer.firstname} ${customer.lastname}`,
      },
      {
        label: 'Property',
        value: ({property}) => `${property.address.split('\n')[0]}, ${property.city}`,
      },
      {
        label: 'Status',
        html: (row) => {
          let tags = {
            open: 'is-dark',
            closed: 'is-light',
          };

          let state = row.states.slice(0).pop().name;
          let tag = tags[state] || 'is-warning';

          return `<span class="tag ${tag}">${state}</span>`;
        },
      },
      {
        label: 'Created at',
        value: row => date(row.created_at).format('MMMM D YYYY,  h:mm A'),
      },
    ],
  });
};
